import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import React, { useContext, useEffect, useState } from "react";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { initialValues } from "./Schemas/initialValue";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";
import { validationSchema } from "./Schemas/validation";
import MDInput from "components/MDInput";
import { AddOnsContext } from "context/AddOnsContext";
import { addOnsAdd } from "Apis/addOns";
import { updateAddOns } from "Apis/addOns";
import { InputAdornment, Typography } from "@mui/material";

const AddOnsForm = ({ getAddOnsList }) => {
  const { editData } = useContext(AddOnsContext);
  const { setNotification } = useContext(LoginFormContext);
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });

  //setData in Formik...
  const setDataInFormik = async () => {
    formik?.setValues(editData);
  };

  const getStatusLabel = (id) => {
    const status = statusData?.find((item) => item?.value == id);
    return status ? status?.label : "-";
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    }
  }, [formIsEdit]);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    if (!formIsEdit) {
      let response = await addOnsAdd(data);
      if (response?.status === 200) {
        getAddOnsList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateAddOns(data);
      if (response?.status === 200) {
        getAddOnsList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };
  const handleStatusChange = (value) => {
    if (value) {
      formik?.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik?.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  //Formik
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik?.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <MDInput
              type="text"
              name="name"
              required
              label="Add Ons Name"
              variant="standard"
              value={formik?.values?.name}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              fullWidth
            />
            {formik?.touched?.name && formik?.errors?.name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik?.errors?.name}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <MDInput
              type="text"
              name="member_price"
              required
              label="Member Price"
              variant="standard"
              value={formik.values.member_price}
              onChange={(e) => {
                const value = e.target.value;

                // Allow only whole numbers
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("member_price", value);
                }
              }}
              onBlur={formik.handleBlur}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontSize: "13px", color: "#6B7280", mr: "2px" }}>
                      ₹
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
            {formik?.touched?.member_price && formik?.errors?.member_price && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik?.errors?.member_price}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <MDInput
              type="text"
              name="non_member_price"
              required
              label="Non Member Price"
              variant="standard"
              value={formik?.values?.non_member_price}
              onChange={(e) => {
                const value = e.target.value;

                // Allow only whole numbers
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("non_member_price", value);
                }
              }}
              onBlur={formik?.handleBlur}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontSize: "13px", color: "#6B7280", mr: "2px" }}>
                      ₹
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
            {formik?.touched?.non_member_price && formik?.errors?.non_member_price && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik?.errors?.non_member_price}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik?.handleBlur}
              required
            />
            {formik?.touched?.is_active && formik?.errors?.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik?.errors?.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
AddOnsForm.propTypes = {
  getAddOnsList: PropTypes.func,
};
export default AddOnsForm;
